import { Box, Breakpoint, Image, useBreakpoint } from '@betty/moonlight';
import { useMemo } from 'react';
import PartnershipMobileContent from './PartnershipMobileContent';
import PartnershipDesktopContent from './PartnershipDesktopContent';

function PartnershipBanner() {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const ContentComponent = useMemo(() => {
    if (isMobile) {
      return PartnershipMobileContent;
    }
    return PartnershipDesktopContent;
  }, [isMobile]);
  return (
    <Box borderRadius="radius-400" marginBottom="space-1000">
      <Box position="absolute" absoluteFill flex={1}>
        <Image
          name={
            isMobile
              ? 'account.SportTeamsBannerMob'
              : 'account.SportTeamsBanner'
          }
          contentFit="cover"
          width="100%"
          height="100%"
          borderRadius="radius-400"
          opacity={0.9}
        />
      </Box>
      <ContentComponent />
    </Box>
  );
}

export default PartnershipBanner;
